export default "__VITE_ASSET__XA54Md_b__"